import { createStyles, makeStyles } from '@mui/styles';

const useStyles = makeStyles(() =>
  createStyles({
    textarea: {
      resize: 'both'
    }
  })
);

export default useStyles;
